// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-ProfilePage-EmailAddressSection-EmailAddressSection-module__addNewEmail";
var _2 = "webpack-pages-ProfilePage-EmailAddressSection-EmailAddressSection-module__badgeCluster";
var _3 = "webpack-pages-ProfilePage-EmailAddressSection-EmailAddressSection-module__email";
var _4 = "webpack-pages-ProfilePage-EmailAddressSection-EmailAddressSection-module__emailText";
var _5 = "webpack-pages-ProfilePage-EmailAddressSection-EmailAddressSection-module__infoText";
var _6 = "webpack-pages-ProfilePage-EmailAddressSection-EmailAddressSection-module__primaryEmailMessage";
export { _1 as "addNewEmail", _2 as "badgeCluster", _3 as "email", _4 as "emailText", _5 as "infoText", _6 as "primaryEmailMessage" }
